
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ewaste",
      function () {
        return require("private-next-pages/ewaste/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ewaste"])
      });
    }
  